import firebase from 'firebase'
import BackendService from './BackendService'
import CompanyService from './CompanyService'
import ProjectService from './ProjectService'

export default class InviteService extends BackendService {

  private companyService: CompanyService = new CompanyService()
  private projectService: ProjectService = new ProjectService()

  async createInvite (item: any) {
    return await this.$db
      .collection('invites')
      .add(item)
      .then((result: any) => {
        return result
      })
      .catch((error: any) => {
        console.error('Error in addInvite', error)
        return false;
      })
  }

  async deleteInvite (inviteId: string) {
    await firebase.firestore()
      .collection('invites')
      .doc(inviteId)
      .delete();
  }

  async addInvite (item: any, projectIds: Array<string>) {
    try {
      const companyId = item.companyId

      if(!companyId) {
        throw Error;
      }

      const dt = new Date()
      item.added = dt
      item.updated = dt
      item.status = 'NEW'
      item.inviteCode = Math.floor(1000 + Math.random() * 9000) + '-' + Math.floor(1000 + Math.random() * 9000)
      item.projectIds = projectIds

      const batch = this.$db.batch()
      const inviteRef = this.$db.collection('invites').doc()
      const companyRef = this.$db.collection('companies').doc(companyId)

      batch.set(inviteRef, item)
      batch.update(companyRef, { invites: firebase.firestore.FieldValue.arrayUnion(item.email)})
      projectIds.forEach((id: string) => {
        const projectRef = this.$db.collection('projects').doc(id)
        batch.update(projectRef, { invites: firebase.firestore.FieldValue.arrayUnion(item.email)})
      })

      batch.commit()
        .then(() => {
          return true;
        })
        .catch((error: any) => {
          console.error('Error in BATCH addInvite', error);
          return false;
        })
    } catch (error) {
      console.log('addInvite catch error', error)
    }
  }

  async acceptInvite (invite: any, companyId: string, userId: string, firstName: string, lastName: string, email: string) {
    try {
      if (!companyId || !userId) {
        throw Error;
      }

      await this.companyService.addCompanyUser(companyId, userId, firstName, lastName, email, 'ACTIVE', false)

      const promises: Promise<any>[] = [];
      invite.projectIds.forEach((projectId: string) => {
        promises.push(
          this.projectService.addProjectUser(projectId, userId, firstName, lastName, email, 'ACTIVE', false)
        )
      })
      await Promise.all(promises)
      await this.deleteInvite(invite.id)
      return true
    } catch (error) {
      console.log('acceptInvite catch error', error)
      return false
    }
  }

}

export const inviteService = new InviteService()